import { GET_CLIENTS_FAILURE } from 'modules/clients/types';
import { GET_EXPENSE_DASHBOARD_FAILURE } from './expenseManagerDashboard.types';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { connect } from 'react-redux';
import { getClients } from 'modules/clients/clients.actions';
import { getExpenseDashboard } from './expenseManagerDashboard.actions';
import { setPageTitle, showToast } from 'modules/layout/layout.actions';
import ExpenseManagerDashboardComponent from './expenseManagerDashboard.component';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const INITIAL_FILTERS = { clientId: null, fileId: null, expenseAnalystName: null };

const ExpenseManagerDashboardContainer = (props) => {
  const { clients } = props;

  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [isLoadingLookups, setIsLoadingLookups] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      setIsLoadingLookups(true);

      const clientsResult = await props.getClients();
      if (clientsResult.type === GET_CLIENTS_FAILURE) {
        props.showToast('Failed to load clients', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }

      setIsLoadingLookups(false);

      // Single aggregate call returns every table's collection
      const dashboardResult = await props.getExpenseDashboard();
      if (dashboardResult.type === GET_EXPENSE_DASHBOARD_FAILURE) {
        props.showToast('Failed to load expense dashboard', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    };

    props.setPageTitle('EA Manager Dashboard');
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterChange = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  return (
    <ExpenseManagerDashboardComponent
      clients={clients || []}
      filters={filters}
      onFilterChange={handleFilterChange}
      isLoading={isLoadingLookups}
      followUpExpenses={props.followUpExpenses || []}
      followUpVouchers={props.followUpVouchers || []}
      recurringPayables={props.recurringPayables || []}
      coveragePeriods={props.coveragePeriods || []}
      exceptionComments={props.exceptionComments || []}
      expenseAnalystSummaries={props.expenseAnalystSummaries || []}
      isLoadingDashboard={props.isLoadingDashboard}
    />
  );
};

ExpenseManagerDashboardContainer.propTypes = {
  clients: PropTypes.array,
  followUpExpenses: PropTypes.array,
  followUpVouchers: PropTypes.array,
  recurringPayables: PropTypes.array,
  coveragePeriods: PropTypes.array,
  exceptionComments: PropTypes.array,
  expenseAnalystSummaries: PropTypes.array,
  isLoadingDashboard: PropTypes.bool,
  setPageTitle: PropTypes.func.isRequired,
  showToast: PropTypes.func.isRequired,
  getClients: PropTypes.func.isRequired,
  getExpenseDashboard: PropTypes.func.isRequired,
};

ExpenseManagerDashboardContainer.defaultProps = {
  clients: [],
  followUpExpenses: [],
  followUpVouchers: [],
  recurringPayables: [],
  coveragePeriods: [],
  exceptionComments: [],
  expenseAnalystSummaries: [],
  isLoadingDashboard: false,
};

const mapStateToProps = (state) => ({
  clients: state.clients?.unmappedClients,
  followUpExpenses: state.expenseManagerDashboard.followUpExpenses,
  followUpVouchers: state.expenseManagerDashboard.followUpVouchers,
  recurringPayables: state.expenseManagerDashboard.recurringPayables,
  coveragePeriods: state.expenseManagerDashboard.coveragePeriods,
  exceptionComments: state.expenseManagerDashboard.exceptionComments,
  expenseAnalystSummaries: state.expenseManagerDashboard.expenseAnalystSummaries,
  isLoadingDashboard: state.expenseManagerDashboard.isLoading,
});

const actionCreators = {
  setPageTitle,
  showToast,
  getClients,
  getExpenseDashboard,
};

export default connect(mapStateToProps, actionCreators)(ExpenseManagerDashboardContainer);
